// frontend-react/src/components/sales/MethodFields.jsx
import React from 'react';
import {
  PAYMENT_METHODS,
  MOBILE_MONEY_PROVIDERS,
  paymentMethodLabel,
  providerLabel,
} from '../../constants/payment.js';

export default function MethodFields({ title, value, onChange }) {
  const method = String(value?.method || 'cash').toLowerCase();
  const provider = String(value?.provider || 'orange_money').toLowerCase();
  const reference = String(value?.reference || '');
  const note = String(value?.note || '');

  function patch(p) {
    onChange?.({ ...(value || {}), ...p });
  }

  return (
    <div className="border rounded-xl bg-surface-card p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="font-semibold">{title}</div>
        <div className="text-xs text-content-secondary">
          {paymentMethodLabel(method)}
          {method === 'mobile_money' ? ` · ${providerLabel(provider)}` : ''}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
        <div className="md:col-span-1">
          <label className="text-xs text-content-secondary">Méthode</label>
          <select
            value={method}
            onChange={e => patch({ method: e.target.value })}
            className="border rounded-lg px-2 py-2 w-full bg-surface-card"
          >
            {PAYMENT_METHODS.map(m => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
        </div>

        {method === 'mobile_money' ? (
          <>
            <div>
              <label className="text-xs text-content-secondary">Opérateur</label>
              <select
                value={provider}
                onChange={e => patch({ provider: e.target.value })}
                className="border rounded-lg px-2 py-2 w-full bg-surface-card"
              >
                {MOBILE_MONEY_PROVIDERS.map(p => (
                  <option key={p.value} value={p.value}>{p.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-xs text-content-secondary">Référence (optionnel)</label>
              <input
                value={reference}
                onChange={e => patch({ reference: e.target.value })}
                className="border rounded-lg px-2 py-2 w-full"
                placeholder="Ex: N° transaction"
              />
            </div>
          </>
        ) : (
          <>
            <div className="md:col-span-2">
              <label className="text-xs text-content-secondary">Référence (optionnel)</label>
              <input
                value={reference}
                onChange={e => patch({ reference: e.target.value })}
                className="border rounded-lg px-2 py-2 w-full"
                placeholder="Ex: N° virement, chèque, reçu..."
              />
            </div>
          </>
        )}

        <div className="md:col-span-3">
          <label className="text-xs text-content-secondary">Note (optionnel)</label>
          <input
            value={note}
            onChange={e => patch({ note: e.target.value })}
            className="border rounded-lg px-2 py-2 w-full"
            placeholder="Ex: payé par le frère du client, acompte, etc."
          />
        </div>
      </div>
    </div>
  );
}
